// extracted by mini-css-extract-plugin
module.exports = {"info":"info___1xceY","cover":"cover___3pup3"};